import addDays from 'date-fns/addDays'

export const getEndDateFromStartDateDuration = (
  startDate: Date,
  duration: number,
): Date => {
  const safeDuration = Math.floor(duration >= 0 ? duration : 0)
  return addDays(startDate, safeDuration)
}
